import { FC, useState } from 'react'
import { Controller } from 'react-hook-form'
import { Box, Stack, Typography } from '@mui/material'
import { attachmentOrgMaxLength, useFormContextPatient } from '../_utils'
import PatientFormField from '../PatientFormField'
import { msxs } from '../../../../theme/_utils'
import sxs from './_styles/AttachmentOrgStyles'

const AttachmentOrg: FC = () => {
    const { control } = useFormContextPatient()
    const [isFocused, setIsFocused] = useState(false)

    return (
        <Controller
            control={control}
            name="attachmentOrg"
            rules={{
                maxLength: attachmentOrgMaxLength,
            }}
            render={({ field, fieldState: { error } }) => {
                const fieldLength = field.value?.length ?? 0
                return (
                    <PatientFormField
                        variant="input"
                        label="Code de l’organisme de rattachement"
                        status={{
                            error,
                            valid: Boolean(field.value),
                        }}
                        dataCyScope="PatientField"
                        size="0.5"
                        inputProps={{
                            maxLength: attachmentOrgMaxLength,
                            onFocus: () => setIsFocused(true),
                            onBlur: () => setIsFocused(false),
                        }}
                        {...field}
                        noValueText={field.value ?? '0 0 0 0 0 0 0 0 0'}
                        onChange={field.onChange}
                        sideTooltip={
                            <Box gap=".3rem">
                                <Typography sx={sxs.attachmentOrgTextBase}>
                                    L'organisme de rattachement à la caisse d'assurance maladie du patient peut être
                                    retrouvé sur “l'attestation de droit” personnelle du patient.
                                </Typography>
                            </Box>
                        }
                        value={field.value}
                        placeholder="0 0 0 0 0 0 0 0 0"
                        helperText={
                            isFocused && (
                                <Stack flexDirection="row" justifyContent="space-between" sx={sxs.helperTextContainer}>
                                    <Typography
                                        sx={msxs(
                                            sxs.attachmentOrgTextBase,
                                            fieldLength === 9 ? sxs.attachmentOrgTextError : undefined,
                                        )}
                                    >
                                        Maximum 9 caractères acceptés :{' '}
                                    </Typography>
                                    <Typography
                                        sx={msxs(
                                            sxs.attachmentOrgTextBase,
                                            fieldLength === 9 ? sxs.attachmentOrgTextError : undefined,
                                        )}
                                    >
                                        {9 - fieldLength}/{attachmentOrgMaxLength}
                                    </Typography>
                                </Stack>
                            )
                        }
                    />
                )
            }}
        />
    )
}

export default AttachmentOrg
